(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-size-selector]')) return;
    const option = event.target.selectedOptions[0];
    const section = event.target.closest('.product-page');
    const form = event.target.closest('[data-product-form]');
    const price = section?.querySelector('.product-info__price');
    const sku = section?.querySelector('[data-product-sku]');
    const submit = form?.querySelector('.product-form__submit');
    const available = option?.dataset.variantAvailable === 'true';
    if (price && option) price.textContent = option.dataset.variantPrice;
    if (sku && option) sku.textContent = option.dataset.variantSku || '';
    if (submit) {
      submit.disabled = !available;
      submit.textContent = available ? submit.dataset.addLabel : submit.dataset.soldLabel;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
